import { findMostSpecificRoute, replacePathParams } from 'quartz-routing/internal/routeMatchingUtils';
import { preloadGraniteRemote } from '../internal/module-federation/runtime';
import { getBlocklistedRoutes } from './granite-config';
function isSameOrigin(url) {
  return url.origin === window.location.origin;
}
function parseLinkUrl(url) {
  try {
    let parsed;
    if (url.startsWith('/')) {
      parsed = new URL(url, window.origin);
    } else {
      parsed = new URL(url);
    }
    return parsed;
  } catch (_unused) {
    return null;
  }
}
function getMatchingLocalRouteOverride(localRouteOverrides, path) {
  if (!path) {
    return undefined;
  }
  const blocklisted = findMostSpecificRoute(getBlocklistedRoutes(), path);
  if (blocklisted) {
    return undefined;
  }
  const foundKey = findMostSpecificRoute(Object.keys(localRouteOverrides), path);
  if (!foundKey) {
    return undefined;
  }
  return localRouteOverrides[foundKey];
}
export function bindLinkRewriter(history, localRouteOverrides) {
  function linkRewriterFn(e) {
    if (!(e.target instanceof HTMLElement)) {
      return;
    }
    const link = e.target.closest('a');
    if (!link) {
      return;
    }
    if (link.target === '_blank' || link.hasAttribute('download') || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      return;
    }
    const href = link.getAttribute('href');
    if (!href) {
      return;
    }
    const linkUrl = parseLinkUrl(href);
    if (!linkUrl || !isSameOrigin(linkUrl)) {
      return;
    }
    const matchingOverride = getMatchingLocalRouteOverride(localRouteOverrides, linkUrl.pathname);
    if (matchingOverride) {
      if (matchingOverride.remoteModule) {
        preloadGraniteRemote(matchingOverride.remoteModule);
      }
      e.preventDefault();
      history.push(replacePathParams(matchingOverride.path, linkUrl.pathname) + linkUrl.search);
    }
  }
  document.addEventListener('click', linkRewriterFn, true);
  return () => {
    document.removeEventListener('click', linkRewriterFn, true);
  };
}